module.exports = __webpack_public_path__ + "04_very_short_yellow.7f08714d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/04_very_short_yellow.png
// module id = 1Ae/
// module chunks = 0